// Gedeelde hulp voor filteren, sorteren en parameters (niet geëxporteerd uit de package).
import type { Celwaarde, Context, Kolom, Lijst } from './typen.js';

export const collator = new Intl.Collator('nl', { sensitivity: 'base', numeric: true });

export function filterbaar<R, C extends Context>(k: Kolom<R, C>): boolean {
  return k.filter ?? (k.type === 'keuzelijst' || k.type === 'datum' || k.type === 'tekst');
}

export function sorteerbaar<R, C extends Context>(k: Kolom<R, C>): boolean {
  return k.sorteer ?? k.type !== 'overig';
}

export function vindKolom<R, C extends Context>(lijst: Lijst<R, C>, sleutel: string): Kolom<R, C> | undefined {
  return lijst.kolommen.find((k) => k.sleutel === sleutel);
}

/** `null`, `undefined` en `''` zijn één lege waarde. */
export function norm(w: Celwaarde): string | null {
  return w === null || w === undefined || w === '' ? null : String(w);
}

export function label<R, C extends Context>(k: Kolom<R, C>, waarde: string, ctx: C): string {
  return k.waardeLabel && ctx.t ? k.waardeLabel(waarde, ctx.t) : waarde;
}

export const klein = (s: string) => s.toLocaleLowerCase('nl');
